/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiService from './index'

export const getChatsRooms = async (userId:string) => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/chats/${userId}`)
}

export const getChatsHistory = async (roomId:string,userId:string) => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/chat/${roomId}/history/${userId}`)
}

export const sendMessage = async (roomId:string, payload:any) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/ai/handle/${roomId}`, payload)
}
export const updateMessage = async (roomId:string, payload:any) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL_V3}/ai/update/${roomId}`, payload)
}

export const createChat = async (payload:any) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/CreateChat`,payload)
}
export const deleteChatRoom = async (roomId:string,userId:string) => {
  return await apiService.delete(`${process.env.REACT_APP_BACKEND_URL_V3}/chat/${roomId}/${userId}`)
}
